import { BrandDocuments } from '@src/api';

import { EnterType, LoginEnterType } from '../../login.model';

export type PolicyDocumentType = BrandDocuments;
export type EnterTypeEnum = LoginEnterType;
export const EnterTypeEnum = EnterType;
